// Oculta las tarjetas/pestañas de balance de permisos del año (Autoservicio y
// Expediente de Empleados) mientras RRHH termina de cargar los balances.
// Cambiar a true para volver a mostrarlas.
export const MOSTRAR_BALANCE_PERMISOS = false;

// Todos los permisos del año (personal y cumpleaños) están en cero a nivel del
// sistema y se cargan a partir de esta fecha. Antes de ella Autoservicio muestra
// la tarjeta con la nota y no deja elegir esos tipos de solicitud.
export const FECHA_CARGA_PERMISOS = new Date(2027, 0, 1);
export const permisosDelAnoCargados = () => new Date() >= FECHA_CARGA_PERMISOS;
